module.exports = __webpack_public_path__ + "media/music1.d1bf8a00.mp3";